// ============================================================
// PeticionesTypeAccess.js — Capa 2 (acceso por tipo)
// Wrappers de las llamadas que consume la matriz de Permisos por tipo.
//
// Sigue el patrón estándar de peticiones_API/: axios + Bearer +
// REACT_APP_API_URL + handleAuthError (redirección al login en 401/403).
// ============================================================

import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;

function authConfig(extra = {}) {
  return {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    ...extra,
  };
}

// Lista de tipos del inventario (para pintar las filas de la matriz).
// GET /api/inventario/tipos → { data, count }
export async function fetchTiposInventario() {
  try {
    const { data } = await axios.get(`${API_URL}/api/inventario/tipos`, authConfig());
    return Array.isArray(data?.data) ? data.data : [];
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}

// Roles del sistema para el selector de destinatarios.
// GET /api/inventario/type-access/roles → ["Administrador", ...]
export async function fetchRolesTipoAcceso() {
  try {
    const { data } = await axios.get(`${API_URL}/api/inventario/type-access/roles`, authConfig());
    return Array.isArray(data) ? data : [];
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}

// Resumen de accesos: cuántos tipos tiene cada rol y cada persona.
// GET /api/inventario/type-access/summary → { roles: {...}, personas: {...} }
export async function fetchResumenTipoAcceso() {
  try {
    const { data } = await axios.get(`${API_URL}/api/inventario/type-access/summary`, authConfig());
    return {
      roles: (data && data.roles) || {},
      personas: (data && data.personas) || {},
    };
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}

// Matriz de un destinatario (rol o persona).
// GET /api/inventario/type-access?role_name=... | ?person_id=...
// → { target, items: [{ asset_type_id, can_view, can_edit }] }
export async function fetchMatrizTipoAcceso(target) {
  try {
    const params = target.role_name != null
      ? { role_name: target.role_name }
      : { person_id: target.person_id };
    const { data } = await axios.get(`${API_URL}/api/inventario/type-access`, authConfig({ params }));
    return data;
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}

// Guardar (reescribir) la matriz de un destinatario.
// PUT /api/inventario/type-access  { role_name|person_id, items: [...] }
export async function guardarMatrizTipoAcceso(payload) {
  try {
    const { data } = await axios.put(`${API_URL}/api/inventario/type-access`, payload, authConfig());
    return data;
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
}
